// Types for the merchants call list ("Mijozlar") — GET /api/support/renewals/ (tasks 0148, 0153).

import type { Ordering } from "@/shared/lib/ordering";

export type RenewalStatus = "expiring" | "expired";
export type RenewalKind = "all" | "free" | "paid";

// Mirrors RenewalsViewSet.ordering_fields on the backend; `-field` = descending, nulls last.
export type RenewalSortField =
  | "user__first_name"
  | "is_free"
  | "end_date"
  | "active_agreements"
  | "portfolio_usd"
  | "accepted_clients_count"
  | "clients_count"
  | "last_login_at"
  | "active_days_30";
export type RenewalOrdering = Ordering<RenewalSortField>;

export const PAGE_SIZE = 25;
export const DAY_OPTIONS = [7, 14, 30] as const;

export interface RenewalParams {
  status: RenewalStatus;
  days: number;
  kind: RenewalKind;
  search: string;
  ordering: RenewalOrdering;
  page: number;
}

export interface RenewalRow {
  user_id: number;
  full_name: string;
  phone_number: string;
  premium_id: number;
  start_date: string;
  end_date: string;
  days_left: number; // negative when already expired
  is_free: boolean;
  is_repeatable: boolean;
  will_renew: boolean | null; // null for expired rows
  balance: string;
  free_premiums_count: number;
  paid_orders_count: number;
  active_agreements: number;
  total_agreements: number;
  clients_count: number;
  // Clients with a complete KYC profile who accepted at least one of the merchant's agreements.
  accepted_clients_count: number;
  portfolio_som: string;
  // Outstanding of ACTIVE agreements in USD; null when no USD rate was available.
  portfolio_usd: string | null;
  agreements_30d: number;
  last_active_day: string | null;
  // Latest merchant-app login (ISO datetime); null when the merchant never logged in.
  last_login_at: string | null;
  active_days_30: number;
}

export interface Paginated<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}
